import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { CLASS_SLUG_PARAM } from './class.model';
import { ClassQuery } from './class.query';
import { ClassService } from './class.service';

export const classDetailResolver: ResolveFn<void> = (route) => {
  const classService = inject(ClassService);
  const classQuery = inject(ClassQuery);
  const router = inject(Router);
  const classSlug = route.paramMap.get(CLASS_SLUG_PARAM);

  if (!classSlug) {
    return;
  }

  const found = classService.setActiveBySlug(classSlug);
  if (!found) {
    router.navigate(['/classes']);
    return;
  }

  if (!classQuery.getActiveId()) {
    return;
  }

  return;
};
